import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import * as homeInitialState from '../initialState';
import { AbsolutePositioned } from '../../../components/Layout/AbsolutePositioned';
import { Screen, SplitScreen, SplitScreenContentHolder } from '../../../components/Layout/Screen';
import { ContentContainer } from '../../../components/Layout/ContentContainer';
import LineLink from '../../../components/LineLink';
import TextBlock from '../../../components/TextBlock';
import Title from '../../../components/Title';
import SocialMedia from '../../../components/SocialMedia';

// Assets
import { brandColors, device } from '../../../styles/variables';
import office from '../../../assets/images/RD_Team_image_1_blue.jpg';

const StyledScreen = Screen.extend`
  position: relative;
  overflow: hidden;
  background: url(${office});
  background-size: cover;
  background-position: center;
  @media only screen and (max-width: 1000px) {
    background-position-x: -290px;
  }
`;

const Overlay = AbsolutePositioned.extend`
  background: hsla(234, 20%, 30%, 0.6);
  height: 50%;
`;

const LineLinksPosition = AbsolutePositioned.extend`
  width: 100%;
  box-sizing: border-box;

  .featureLineLinks {
    position: relative;
    width: 80%;
    pointer-events: all;
  }
`;

const LineLinksSplitScreenContent = SplitScreenContentHolder.extend`
  padding: 0 0 0 40px;
  @media ${device.laptop} {
    padding: 0 0 0 108px;
  }
`;

const ContentHolder = styled.div`
  position: relative;
  padding: 0;
  height: 100%;
  width: 100%;
`;

const TextBlockContainer = styled.div`
  margin: 122px 0 0 0;
`;

const TitleContainer = styled.div`
  margin: -57px 0 0 0;
  @media ${device.tablet} {
    margin: -89px 0 0 0;
  }
`;

class FooterScreen extends React.PureComponent {
  constructor(props) {
    super(props);

    // need to set the store for home
    // place to set all the required elements
    // but for now it is just stored in the initialState.js file
    this.homeDetails = homeInitialState.default;
  }

  render() {
    return (
      <StyledScreen className="footer-screen">
        <ContentHolder>
          <ContentContainer>
            <TextBlockContainer>
              <TextBlock color={brandColors.white}>
                <p>
                  We&apos;re very passionate about what we do because we believe our work makes a
                  difference.
                </p>
              </TextBlock>
            </TextBlockContainer>
          </ContentContainer>
        </ContentHolder>
        <Overlay top="unset" bottom="0" right="0">
          <ContentHolder>
            <ContentContainer>
              <TitleContainer>
                <SocialMedia />
                <Title color={brandColors.white}>Connect with us</Title>
              </TitleContainer>
            </ContentContainer>

            <LineLinksPosition bottom="13%" top="unset">
              <SplitScreen>
                <LineLinksSplitScreenContent direction="right">
                  <LineLink
                    className="featureLineLinks"
                    linkText="show me examples"
                    subtitle="see our work"
                    linkColor={brandColors.orange}
                    linkOverlayType="case-studies"
                    lineAnimate
                    active
                  />
                </LineLinksSplitScreenContent>
              </SplitScreen>
              <SplitScreen>
                <LineLinksSplitScreenContent direction="left">
                  <LineLink
                    className="featureLineLinks"
                    linkText="get in touch"
                    subtitle="contact us"
                    linkColor={brandColors.yellow}
                    route="/contact"
                    lineAnimate
                    active
                  />
                </LineLinksSplitScreenContent>
              </SplitScreen>
            </LineLinksPosition>
          </ContentHolder>
        </Overlay>
      </StyledScreen>
    );
  }
}

export default connect()(FooterScreen);



// WEBPACK FOOTER //
// ./src/pages/Home/screens/Footer.jsx